import { ApiSliceState } from "./types";

export const pendingReducer = (state: ApiSliceState, action: any) => {
  const endpoint = action.meta.arg.endpointName;
  const requestId = action.meta.requestId;
  state[endpoint][requestId] = {
    isLoading: true,
    completed: false,
    startedTimeStamp: action.meta.startedTimeStamp,
  };
};

export const rejectedReducer = (state: ApiSliceState, action: any) => {
  const endpoint = action.meta.arg.endpointName;
  const requestId = action.meta.requestId;
  state[endpoint][requestId] = {
    isLoading: false,
    completed: true,
    error: {
      message: action.error.message,
      data: action.payload?.data ?? undefined,
    },
    startedTimeStamp: state[endpoint][requestId].startedTimeStamp,
    completedTimeStamp: Date.now(),
  };
};

export const fulfilledReducer = (state: ApiSliceState, action: any) => {
  const endpoint = action.meta.arg.endpointName;
  const requestId = action.meta.requestId;
  state[endpoint][requestId] = {
    isLoading: false,
    completed: true,
    startedTimeStamp: state[endpoint][requestId].startedTimeStamp,
    completedTimeStamp: action.meta.fulfilledTimeStamp
  };
};
